import { useState, useEffect, useCallback } from "react";
import Table from "../../table/Table";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { Configuration, chackValveDetailTitle } from "../../../constants";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Button, Card, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import { routes } from "../../../routers/routes";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";
import LoadingComponent from "../../lodingComponent";
import { Filter } from "react-feather";


const ChackValveDetail = () => {
    const [chackValveDetail, setChackValveDetail] = useState([]);
    const [selectedId, setSelectedId] = useState<string>("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

    const navigate = useNavigate();
    const role = useAppSelector((state) => state.role.role);




    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        searchQuery,
        setSearchQuery,
        filterOn,
        setSortBy,
        loading
    } = usePagination({
        endpoint: `/chackvalvedetail`,
        filterOn:'ValveNumber',
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])




    const handleDelete = (id: string) => {
        setSelectedId(id);
        setIsDeleteModalOpen(true);
    }

    const handleUpdate = (id: string) => {
        navigate(`/update-chack-valve-detail/${id}`);
    }

    const handleDeleteConfirm = async () => {
        try {
            const response = await ApiService.axiosApi(`/chackvalvedetail/${selectedId}`, {
                method: 'DELETE'
            })
            if (response.success) {
                toast.success(response.message || "Chack Valve Detail Deleted");
                setRefresh(refresh => !refresh);
                setIsDeleteModalOpen(false)
            } else {
                toast.error(response.message || "Unable to delete Chack Valve Detail");
            }
        } catch (error: any) {
            toast.error(error.message || "Unable to delete Chack Valve Detail");
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle={chackValveDetailTitle} parent={Configuration} />

           
                <Card>
                    
                    <CommonCardHeader title="Chak Valve Detail  List" headClass="pb-3" />
                    <div className="d-flex justify-content-between">
                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('ChackName')}>
                         <Filter/>
                       </button>
                           </div>
                        
                    </div>
                    {role === "Administrator" && (
                        <div >
                            <Button onClick={() => navigate(routes.AddChackValveDetail)} color="primary" className="mb-2 mx-2">Add Chak Valve Detail</Button>
                        </div>
                    )}   
                      
                
                    
                    </div>
                     {loading?<LoadingComponent/>:  <Table
                        data={data}
                        columns={[

                            { header: "Valve Number", accessor: "valveNumber" },
                            { header: "Chak Name", accessor: "chakName" },
                            { header: "Valve On", accessor: "on" }
                        ]}

                        buttons={[
                            { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger" }
                        ]}
                    />}
                   
                    <div className=" d-flex justify-content-end align-content-center" style={{marginRight:'10px', marginTop:'10px'}}>
                        <p style={{ marginRight: '10px' , marginTop:'8px'}}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon"/>
                        </button>
                        <button
                             className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon"/>
                        </button>
                    </div>
                </Card>
                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Chack Valve Detail</ModalHeader>
                    <ModalBody>Are you sure you want to delete this Chak Valve Detail?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={handleDeleteConfirm}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>




           
        </>
    )
}


export default ChackValveDetail;